const actionDetail = ({
  position = '',
  textOfButtonOrLink = '',
  pageOrScreen = '',
  referrer = '',
} = {}) => ({
  ActionDetail: { position, textOfButtonOrLink, pageOrScreen, referrer },
});

export default actionDetail;
